import * as Types from '../../actions/type'
const initialState = {
    loading: false,
    loaded: false,
    data: [],
    params: null,
    allData: [],
}

const dummyCurrency = {currencies: [],
    page:1,
    pages:1,
    limit: 10,
    total: 0,
    allData: []
}
const getIndex = (arr, arr2, arr3, params = {}) => {
    if (arr2.length > 0) {
      let startIndex = arr.findIndex(i => i.id === arr2[0].id) + 1
      let endIndex = arr.findIndex(i => i.id === arr2[arr2.length - 1].id) + 1
      let finalArr = [startIndex, endIndex]
      return (arr3 = finalArr)
    } else {
      let finalArr = [params.page, params.pages]
      return (arr3 = finalArr)
    }
}


export const currenyDetails = ( state=initialState, action) =>{
    switch (action.type){
        case Types.GET_CURRENCY_DETAILS:
            return { ...state, loading: true };
        case Types.GET_CURRENCY_DETAILS_SUCCESS: 
        let newData = {
        }
        console.log("reducerresponse",action.payload.currencies)
        if(Object.keys(action.payload).length > 0){
            newData = { ...action.payload};
            newData.allData = [...action.payload.currencies]
        }else{
            newData = {...dummyCurrency}
        }
        newData.sortIndex = getIndex(newData.allData, state.data, state.sortIndex, {...newData})
        return { ...state, loading: false, loaded: true, payload: newData }
        case Types.GET_CURRENCY_DETAILS_FAILURE:
            return { ...state, loading: false, loaded: false, error: action.payload }
        case Types.ADD_CURRENCY_DATA: 
        let updatedData = { ...state.payload}
        updatedData.currencies.unshift({...action.payload});
        updatedData.allData = [...updatedData.currencies];
        updatedData.total = updatedData.currencies.length;
        updatedData.sortIndex = getIndex(updatedData.currencies, 
                                        updatedData.allData, 
                                        state.payload.sortIndex, 
                                        {...updatedData})
        return { ...state, loading: false, loaded: true, payload: updatedData}
        case Types.UPDATE_CURRENCY_DATA:
            let updatingData = { ...state.payload}           
            let newCurrency = updatingData.currencies.map((item) =>{
                if(item._id === action.payload._id){
                    item = {...action.payload}
                }
                return item
            })
            updatingData.currencies = [...newCurrency];
            return {
                ...state, loading: false, loaded: true, payload: {...updatingData}
            }
        case Types.DELETE_CURRENCY_DATA:
                let deleteData = { ...state.payload}
                let deleteingCurrency = deleteData.currencies.filter((item) =>{
                    return item._id !== action.payload._id;
                })
                deleteData.currencies = [...deleteingCurrency];
                deleteData.allData = [...deleteingCurrency];
                deleteData.total = deleteData.currencies.length;
                deleteData.sortIndex = getIndex(deleteData.currencies, 
                                                deleteData.allData, 
                                                state.payload.sortIndex, 
                                                {...deleteData})
                return {
                    ...state, loading: false, loaded: true, payload: {...deleteData}
                }
        default: 
            return state
    }
}



